module.exports = __webpack_public_path__ + "img/small-wrench.6d1a3810.svg";